// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ILogoInfoDto } from './ILogoInfoDto';
import {
    ILogoInfoDtoFromJSON,
    ILogoInfoDtoFromJSONTyped,
    ILogoInfoDtoToJSON,
    ILogoInfoDtoToJSONTyped,
} from './ILogoInfoDto';

/**
 * 
 * @export
 * @interface IOrgBalanceResponse
 */
export interface IOrgBalanceResponse {
    /**
     * 
     * @type {string}
     * @memberof IOrgBalanceResponse
     */
    org_name: string;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceResponse
     */
    org_id: number;
    /**
     * 
     * @type {string}
     * @memberof IOrgBalanceResponse
     */
    org_type: IOrgBalanceResponseOrgTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceResponse
     */
    hsa_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceResponse
     */
    notional_balance?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrgBalanceResponse
     */
    status: IOrgBalanceResponseStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IOrgBalanceResponse
     */
    is_locked?: boolean;
    /**
     * 
     * @type {ILogoInfoDto}
     * @memberof IOrgBalanceResponse
     */
    logo_info?: ILogoInfoDto;
}

/**
* @export
* @enum {string}
*/
export enum IOrgBalanceResponseOrgTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}
/**
* @export
* @enum {string}
*/
export enum IOrgBalanceResponseStatusEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    ABANDONED = 'ABANDONED',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}


/**
 * Check if a given object implements the IOrgBalanceResponse interface.
 */
export function instanceOfIOrgBalanceResponse(value: object): value is IOrgBalanceResponse {
    if (!('org_name' in value) || value['org_name'] === undefined) return false;
    if (!('org_id' in value) || value['org_id'] === undefined) return false;
    if (!('org_type' in value) || value['org_type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function IOrgBalanceResponseFromJSON(json: any): IOrgBalanceResponse {
    return IOrgBalanceResponseFromJSONTyped(json, false);
}

export function IOrgBalanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrgBalanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'org_name': json['org_name'],
        'org_id': json['org_id'],
        'org_type': json['org_type'],
        'hsa_balance': json['hsa_balance'] == null ? undefined : json['hsa_balance'],
        'notional_balance': json['notional_balance'] == null ? undefined : json['notional_balance'],
        'status': json['status'],
        'is_locked': json['is_locked'] == null ? undefined : json['is_locked'],
        'logo_info': json['logo_info'] == null ? undefined : ILogoInfoDtoFromJSON(json['logo_info']),
    };
}

export function IOrgBalanceResponseToJSON(json: any): IOrgBalanceResponse {
    return IOrgBalanceResponseToJSONTyped(json, false);
}

export function IOrgBalanceResponseToJSONTyped(value?: IOrgBalanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_name': value['org_name'],
        'org_id': value['org_id'],
        'org_type': value['org_type'],
        'hsa_balance': value['hsa_balance'],
        'notional_balance': value['notional_balance'],
        'status': value['status'],
        'is_locked': value['is_locked'],
        'logo_info': ILogoInfoDtoToJSON(value['logo_info']),
    };
}

